@if (filtersForm() && controlName()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    title="{{ title() }}"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
    [showToggle]="false"
  ></vectronic-filter-header>

  <div
    [hidden]="!isFilterHidden()"
    [formGroup]="filtersForm()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
    class="filter-body"
  >
    <mat-form-field appearance="outline">
      <mat-label>{{ title() }}</mat-label>
      <mat-select
        [formControlName]="controlName()"
        [value]="filtersForm().get(controlName()).value"
      >
        @for (mode of fixTypeModeList; track mode.value) {
          <mat-option [value]="mode.value">{{ mode.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
